export const DA_EMOTE_TYPE = 'da-draft-plugin-emote';
export const DA_COMM_EMOTE = 'DA_COMM_EMOTE';
export const DA_OFF_EMOTE = 'DA_OFF_EMOTE';

//# sourceMappingURL=types.js.map